export default function getAvatarFilter() {
	"ngInject";
	return (input) => {
		try {
			let avatar = input.uris.Avatar;
			return `${avatar}${avatar.indexOf("timestamp") === -1 ? "?" : "&"}s=200`;
		} catch (e) {
			return "";
		}
	};
}


// WEBPACK FOOTER //
// ./sources/utility/get-avatar/get-avatar.filter.js